import { Logo } from './Logo'

export default function PageLoader() {
  return (
    <div
      data-app-page-loader
      className="fixed inset-0 z-[20000] flex min-h-screen items-center justify-center bg-[#f7fcf9]"
    >
      <Logo forceLight size="lg" className="!h-auto w-[min(80vw,20rem)]" />
    </div>
  )
}
